// ----------------------------------------------------------------------------
// Snippet: Card Label
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_card-label.scss';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import iamFormElement from 'scripts/classes/iamFormElement';
// -------------------------------------
// Web Component
// -------------------------------------

class iamProductLabel extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Variables
    this.sectionId = this.dataset.sectionId;

    // Initialize modules
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      context: this.iamForm,
      source: "card-label.js"
    });
    iamotaEventHandler.trigger('productForm:label:init', {
      iamProductLabel: this
    }, {
      context: this
    });
  }
  onVariantChange(_ref) {
    var {
      variant
    } = _ref;
    this.refreshState(variant);
  }
  refreshState() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.iamForm.getCurrentVariant();
    // Check if the variant is on sale
    var isOnSale = variant.compare_at_price > variant.price;
    console.log('Sale state:', isOnSale);
    // Update the label visibility based on the sale state
    this.querySelector('.card__tag--sale').classList.toggle('hidden', !isOnSale);

    // Update the label text
    this.querySelector('.card__tag--sale').textContent = translate('custom.tags.sale');
  }
}

// Define the custom element
customElements.define('iam-product-label', iamProductLabel);